import React, { useState } from "react";
import {
    format,
    startOfMonth,
    endOfMonth,
    eachDayOfInterval,
    addMonths,
    subMonths,
    isSameDay
} from "date-fns";
import { toast } from "react-toastify";

export default function DateCalendar({
    selectedDate,
    onSelectDate
}) {
    const [currentMonth, setCurrentMonth] = useState(
        selectedDate || new Date()
    );

    const startOfCurrentMonth = startOfMonth(currentMonth);
    const endOfCurrentMonth = endOfMonth(currentMonth);

    const daysInMonth = eachDayOfInterval({
        start: startOfCurrentMonth,
        end: endOfCurrentMonth
    });

    const goToNextMonth = () => setCurrentMonth(addMonths(currentMonth, 1));
    const goToPreviousMonth = () => setCurrentMonth(subMonths(currentMonth, 1));

    const handleDateClick = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const clicked = new Date(date);
        clicked.setHours(0, 0, 0, 0);

        if (clicked < today) {
            toast.warning("Please select today or a future date", {
                position: "top-center",
                theme: "colored",
                hideProgressBar: true
            });
            return;
        }

        onSelectDate(clicked);
    };

    return (
        <div className="bg-white border-2 border-theme_clr1 rounded-2xl p-4">
            <div className="calendar-wrapper max-w-[312px] w-full text-center mx-auto">

                {/* Selected date display */}
                {selectedDate && (
                    <div className="text-theme_clr1 text-sm font-medium mb-3">
                        {format(selectedDate, "MMMM dd, yyyy")}
                    </div>
                )}

                {/* Month Navigation */}
                <div className="text-sm font-medium flex items-center justify-between mb-2">
                    <button onClick={goToPreviousMonth} className="h-[30px] w-[40px]">
                        <i className="bi bi-chevron-left"></i>
                    </button>
                    <span>{format(currentMonth, "MMMM yyyy")}</span>
                    <button onClick={goToNextMonth} className="h-[30px] w-[40px]">
                        <i className="bi bi-chevron-right"></i>
                    </button>
                </div>

                {/* Days */}
                <div className="grid grid-cols-7 gap-[2px] text-center">
                    {["S", "M", "T", "W", "T", "F", "S"].map((d, i) => (
                        <div key={i} className="text-xs h-[35px] flex items-center justify-center">
                            {d}
                        </div>
                    ))}

                    {/* Empty slots */}
                    {Array.from({ length: startOfCurrentMonth.getDay() }).map((_, i) => (
                        <div key={i}></div>
                    ))}

                    {/* Dates */}
                    {daysInMonth.map(date => {
                        const isToday = isSameDay(date, new Date());
                        const isSelected = selectedDate && isSameDay(date, selectedDate);

                        return (
                            <div
                                key={date.toISOString()}
                                onClick={() => handleDateClick(date)}
                                className={`
                  h-[36px] w-[36px] flex items-center justify-center rounded-full
                  text-sm cursor-pointer transition
                  ${isSelected ? "bg-theme_clr1 text-white" : ""}
                  ${isToday && !isSelected ? "border-2 border-theme_clr1" : ""}
                  hover:bg-theme_clr1 hover:text-white
                `}
                            >
                                {format(date, "d")}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
